import React, { useState } from 'react';
import {
	currentAnnouncement,
	dismissAnnouncement,
	isAnnouncementDismissed,
} from '../utils/announcements';

const bannerStyle = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexWrap: 'wrap',
	gap: '12px',
	padding: '10px 16px',
	background: '#1a3a5c',
	color: '#fff',
	fontSize: '14px',
	lineHeight: '1.25',
	boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
};

export default function AnnouncementBanner() {
	const message = currentAnnouncement;
	const [hidden, setHidden] = useState(
		() => !message || isAnnouncementDismissed(message.id),
	);

	if (!message || hidden) return null;

	const onDismiss = () => {
		dismissAnnouncement(message.id);
		setHidden(true);
	};

	return (
		<div className="announcement-banner" style={bannerStyle} role="status">
			<span>{message.text}</span>
			<button
				type="button"
				className="btn btn-sm btn-outline-light"
				onClick={onDismiss}
			>
				Dismiss
			</button>
		</div>
	);
}
